const trimId = (value) => String(value ?? "").trim();

export const getStatementBatchId = (item) =>
  trimId(item?.batch_id ?? item?.batchId ?? item?.BatchId);

export const getStatementLegCount = (item) => {
  const raw = item?.leg_count ?? item?.legCount ?? item?.LegCount;
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : 0;
};

/**
 * Groups same-day statement rows that share a Pix lote id.
 * Preserves first-seen order so day grouping is not reshuffled.
 */
export const groupDayItemsByPixBatch = (items = []) => {
  const groups = [];
  const batchIndex = new Map();

  for (const item of items) {
    const batchId = getStatementBatchId(item);
    const legCount = getStatementLegCount(item);
    if (!batchId || legCount < 2) {
      groups.push({ type: "single", item });
      continue;
    }

    if (batchIndex.has(batchId)) {
      groups[batchIndex.get(batchId)].legs.push(item);
      continue;
    }

    batchIndex.set(batchId, groups.length);
    groups.push({ type: "batch", batchId, legs: [item] });
  }

  return groups;
};

export const buildPixBatchStatementItem = (legs = []) => {
  if (!Array.isArray(legs) || legs.length === 0) return null;
  const first = legs[0];
  const totalFromApi = Number(
    first?.batch_total_amount ?? first?.batchTotalAmount ?? 0,
  );
  const summed = legs.reduce(
    (acc, leg) => acc + Math.abs(Number(leg?.amount ?? leg?.operation_amount ?? 0)),
    0,
  );
  const total = totalFromApi > 0 ? totalFromApi : summed;
  const isCredit = String(first?.operation ?? "").toLowerCase() === "credit"
    || Number(first?.amount) > 0;
  const signedTotal = isCredit ? Math.abs(total) : -Math.abs(total);

  return {
    ...first,
    amount: signedTotal,
    operation_amount: signedTotal,
    operation: isCredit ? "credit" : "debit",
    batch_id: getStatementBatchId(first),
    batch_total_amount: Math.abs(total),
    batch_status: first?.batch_status ?? first?.batchStatus ?? null,
    leg_index: null,
    leg_count: getStatementLegCount(first) || legs.length,
    batch_legs: legs,
  };
};
